import { clsx } from 'clsx';

type TProgressPidProps = {
  progress: number;
  total: number;
  course?: boolean;
};

export const ProgressPid: React.FC<TProgressPidProps> = ({
  progress,
  total,
  course,
}) => {
  const advance = (progress * 100) / total;

  return (
    <div className="tw-w-full tw-flex tw-items-center">
      {/*Se define los valores del semaforo de pid  */}
      <div
        className={clsx(
          'tw-p-0.1 tw-flex  tw-mr-0.8 tw-items-center tw-rounded-0.8 tw-h-0.8 tw-w-full',
          progress <= 35 && !course && 'tw-bg-alert-100',
          progress > 35 && progress <= 79 && !course && 'tw-bg-warning-100',
          progress > 79 && !course && 'tw-bg-success-100',
          course && 'tw-bg-neutral-light-500',
        )}
      >
        <span
          style={{ width: `${advance}%` }}
          className={clsx(
            `tw-h-[0.6rem] tw-rounded-0.8 tw-w-[${advance}%]`,
            progress <= 35 && !course && 'tw-bg-alert-400',
            progress > 35 && progress <= 79 && !course && 'tw-bg-warning-400',
            progress > 79 && !course && 'tw-bg-success-400',
            course && 'tw-bg-primary-light-500',
          )}
        ></span>
      </div>
      <span className="tw-font-body5 tw-text-neutral-light-800">
        {Math.round(advance)}
        {'%'}
      </span>
    </div>
  );
};
